import { apiSlice } from '../api/apiSlice';

export const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChats: builder.query({
      query: ({ shopid, process } = {}) => {
        const params = new URLSearchParams();
        if (shopid) params.append('shopid', shopid);
        if (process) params.append('process', process);
        return `chat/?${params.toString()}`;
      },
    }),

    searchConnectedShops: builder.query({
      query: ({ userid, shopid, search } = {}) =>
        `conection/searchConnectedShops?userid=${userid || ''}&shopid=${shopid || ''}&search=${encodeURIComponent(
          search || ''
        )}`,
    }),

    createChat: builder.mutation({
      query: (body) => ({
        url: 'chat/',
        method: 'POST',
        body,
      }),
    }),

    getMessages: builder.query({
      query: (arg) => {
        const { chatId, participantId } =
          typeof arg === "string" ? { chatId: arg } : arg;
        const params = new URLSearchParams();
        if (participantId) params.append("participantId", participantId);
        return `message/${chatId}?${params.toString()}`;
      },
    }),

    clearChat: builder.mutation({
      query: ({ chatId, participantId }) => ({
        url: `chat/${chatId}/clear`,
        method: "POST",
        body: { participantId },
      }),
    }),

    getChatBlockStatus: builder.query({
      query: ({ chatId, participantId, targetParticipantId }) => {
        const params = new URLSearchParams({
          participantId,
          targetParticipantId,
        });
        return `chat/${chatId}/block-status?${params.toString()}`;
      },
      providesTags: (_result, _error, { chatId, participantId, targetParticipantId }) => [
        {
          type: "ChatBlock",
          id: `${chatId}:${participantId}:${targetParticipantId}`,
        },
      ],
    }),

    setChatBlockStatus: builder.mutation({
      query: ({ chatId, participantId, targetParticipantId, blocked }) => ({
        url: `chat/${chatId}/block-status`,
        method: "PUT",
        body: { participantId, targetParticipantId, blocked },
      }),
      invalidatesTags: (_result, _error, { chatId, participantId, targetParticipantId }) => [
        {
          type: "ChatBlock",
          id: `${chatId}:${participantId}:${targetParticipantId}`,
        },
      ],
    }),

    sendMessage: builder.mutation({
      query: (body) => ({
        url: 'message/',
        method: 'POST',
        body,
      }),
    }),

    deleteMessage: builder.mutation({
      query: (messageId) => ({
        url: `message/${messageId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetChatsQuery,
  useSearchConnectedShopsQuery,
  useLazySearchConnectedShopsQuery,
  useCreateChatMutation,
  useGetMessagesQuery,
  useSendMessageMutation,
  useDeleteMessageMutation,
  useClearChatMutation,
  useGetChatBlockStatusQuery,
  useSetChatBlockStatusMutation,
} = chatApiSlice;

export default chatApiSlice;
